<template>
  <div>
    <el-form class="login-form" status-icon :rules="loginRules" ref="loginForm" :model="loginForm" label-width="0">
      <el-form-item prop="username">
        <el-input size="medium" @keyup.enter.native="handleLogin" v-model="loginForm.username" auto-complete="off" placeholder="请输入您的帐号">
         <!-- <svg slot="prefix" class="icon" style="margin-top: 19px" aria-hidden="true">
            <use xlink:href="#icon-yonghu"></use>
          </svg> -->
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input size="medium" @keyup.enter.native="handleLogin" :type="passwordType" v-model="loginForm.password" auto-complete="off" placeholder="请输入您的密码">
         <!-- <i class="el-icon-view el-input__icon" slot="suffix" @click="showPassword"></i>
          <svg slot="prefix" class="icon" style="margin-top: 19px" aria-hidden="true">
            <use xlink:href="#icon-mima"></use>
          </svg> -->
        </el-input>
      </el-form-item>
   <!--   <div class="change-method">
        <span @click="changMethod">切换至手机号登录方式</span>
        <svg slot="prefix" style="margin: 19px 0 0 5px; color: #008cc9;" class="icon" aria-hidden="true">
          <use xlink:href="#icon-youjiantou"></use>
        </svg>
      </div> -->
      <el-form-item class="login-button-item">
        <span class="login" @click="handleLogin()">登录</span>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import { randomLenNum } from '@/util/util';
  import { recordLoginTimes} from '@/api/sys/login';
  import { commonConst } from '@/const/code.js';
  import { mapGetters } from 'vuex';

  export default {
    name: 'pwdlogin',
    data() {
      const validateCode = (rule, value, callback) => {
        if (this.code.value != value) {
          this.loginForm.code = '';
          this.refreshCode();
          callback(new Error('请输入正确的验证码'));
        } else {
          callback();
        }
      };
      return {
        loginForm: {
          username: '',
          password: '',
          code: '',
          randomStr: '',
          tenantId:'',
        },
        code: {
            src: '/user/code',
            value: '',
            len: 4,
            type: 'image',
        },
        loginLoading: false,
        loginRules: {
          username: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min: 4, message: '密码长度最少为4位', trigger: 'blur' },
          ],
          code: [
            { required: true, message: '请输入验证码', trigger: 'blur' },
            { min: 4, max: 4, message: '验证码长度为4位', trigger: 'blur' },
          ],
        },
        passwordType: 'password',
      };
    },
    created() {
      let tenant = this.$route.params.tenant;
      console.log("tenant=========",tenant);
        console.log(process.env.VUE_APP_LOCAL_DEVELOPMENT)
        this.refreshCode();
    },
    mounted() {},
    computed: {
    },
    props: ['loginMethod'],
    methods: {

      changMethod(){
        this.$emit('update:loginMethod', 'code')
      },
        refreshCode() {
            this.loginForm.code = '';
            this.loginForm.randomStr = randomLenNum(this.code.len, true);
            this.code.type == 'text'
                ? (this.code.value = randomLenNum(this.code.len))
                : (this.code.src = `${process.env.VUE_APP_BASE_API}/user/code/${this.loginForm.randomStr}`);
        },
      showPassword() {
        this.passwordType == ''
          ? (this.passwordType = 'password')
          : (this.passwordType = '');
      },
      handleLogin() {
          this.$refs.loginForm.validate((valid) => {
              if (valid) {
                  this.loginLoading = true;
                  console.log(/^\d+$/.test(this.loginForm.username))
                  if(/^\d+$/.test(this.loginForm.username)){
                      //手机号
                      this.loginForm.type = 2
                  }else if(this.loginForm.username.indexOf("@") != -1){
                      //邮箱
                      this.loginForm.type = 3
                  }else{
                      //用户名
                      this.loginForm.type = 1
                      this.loginForm.username = this.loginForm.username
                  }
                  //todo  登录接口,目前直接跳转到首页
                  this.$store.dispatch('LoginByUsername', this.loginForm).then(
                      (res) => {
                          if(res.data.code){
                              this.loginLoading = false;
                              this.$message.error(res.data.msg);
                          } else {
                              this.$router.push({path: '/index'});
                              this.$message.success('登录成功');
                              //w登录成功后查询当前登录用户是否有登录
                              //this.saveUserLoing();
                          }
                      }
                  ).catch(
                      (error) => {
                          this.loginLoading = false;
                          if(error.data && error.data.msg){
                              this.$message.error(error.data.msg);
                          }
                          this.refreshCode();
                      })
              }
          });
        },
       saveUserLoing(){
        //console.log("记录登录次数")
         recordLoginTimes().then(res=>{
           //console.log("记录登录次数返回的结果",res)
           let data = res.data.data;

           if(!data){
            // console.log("记录登录次数返回的结果 6666666666666666666666666666666666",res.data)
             this.$confirm('是否确认本月客户服务计划?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning',
             }).then(() => {
               const pathStr = `/biz/plan/planList`;
               let query ={date:"show"};
                 this.$router.push({ path: pathStr,query });
             });
           }
         });
       }

    },
  };
</script>

<style scoped>

  .change-method{
    margin-top: -.15rem;
    margin-bottom: .2rem !important;
  }
	.login-form{
		margin-top: .5rem;
	}
	.login-form >>> .el-input__inner{
		width:100%;
		height:.68rem;
		padding-left: .30rem;
		box-sizing: border-box;
		background:rgba(247,244,251,1);
		border-radius:.10rem;
		font-size: .20rem;
		}
		.login-form >>> .el-form-item{
			margin-bottom: .36rem;
		}
		.login{
			display: inline-block;
			cursor: pointer;
			width:100%;
			height:.65rem;
			background:#4EC8FF;
			border-radius:.10rem;
			text-align: center;
			line-height: .65rem;
			font-size:.24rem;
			font-weight:400;
			color:rgba(255,255,255,1);
		}
		.login-form >>> .el-input__suffix{
			display: none;
		}
		.login-form >>> .el-form-item__error{
			padding-left: .23rem;
			font-size:.20rem;
			font-weight:400;
			color:rgba(235,11,11,1);
		}
		.el-message--success .el-message__content{
			font-size: 14px;
			}
			.el-message .el-message__icon {
				font-size: 16px;
			}
</style>
